import {
  Box,
  Button,
  Card,
  CardContent,
  CardMedia,
  Grid,
  Input,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/bootstrap.css";
import { ChangeEvent, useEffect, useState } from "react";
import CameraAltIcon from "@mui/icons-material/CameraAlt";
import CancelIcon from "@mui/icons-material/Cancel";
import MainContainer from "../../../layout/MainContainer";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { UploadMedia } from "../../../utils/uploadMedia";
import { errorToast, successToast } from "../../../helpers/toast";
import { generateEncryptedKeyBody } from "../../../utils/crypto";
import { useFormik } from "formik";
// import {
//   useAddUserApiMutation,
//   useEditUserMutation,
//   useLazyGetSpecificUserByIdQuery,
// } from "../../../services/users";
import { CommonBody } from "../../../types/General";
import Loader from "../../../helpers/constants/Loader";
// import { useLazyGetSpecificAgentByIdQuery } from "../../../services/agents";
import { Autocomplete } from "@react-google-maps/api";
import {
  useCustomerByIdMutation,
  useGetCustomerByIdMutation,
  useUpdateUserByIdMutation,
  useUpdateVendorByOIdMutation,
} from "../../../services/registration";
import useTranslation from "../../../hooks/Translation";

const UsersForm = () => {
  const [imageId, setImageId] = useState(null);
  const t = useTranslation();
  const onLoad = (autocompleteObj: any) => {
    setAutocomplete(autocompleteObj);
  };
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [profile_picture, setProfilePicture] = useState("");
  const [ByIdDetails, setByIdDetails] = useState<any>(null);
  const navigate = useNavigate();
  const [dialCode, setPhoneCode] = useState("+971");
  // const [editUSERbyId] = useEditUserMutation();
  const { id } = useParams();
  const [fetchApi] = useCustomerByIdMutation();
  const [autocomplete, setAutocomplete] = useState<any>();
  const [editUserByiD] = useUpdateUserByIdMutation();
  // const [addUser] = useAddUserApiMutation();
  // const industry_type = [
  //   { value: "1", label: "WholeSaler" },
  //   { value: "2", label: "Individual" },
  // ];
  const INDUSTRY_TYPE = [
    { value: "1", label: "Retailer" },
    { value: "2", label: "Wholesaler" },
    { value: "3", label: "Distributer" },
  ];
  const onPlaceChanged = async () => {
    if (autocomplete) {
      let place = await (autocomplete as any).getPlace();

      if (place && place.address_components) {
        let address = place.address_components;

        let state,
          city,
          country,
          zip = "";

        address.forEach(function (component: any) {
          let types = component.types;

          if (
            types.indexOf("locality") > -1 ||
            types.indexOf("administrative_area_level_3") > -1
          ) {
            city = component.long_name;
          }
          if (types.indexOf("postal_code") > -1) {
            zip = component.long_name;
          }
          if (types.indexOf("administrative_area_level_1") > -1) {
            state = component?.long_name || "";
          }
          if (types.indexOf("country") > -1) {
            country = component?.long_name || "";
          }
        });
        var lat = place.geometry.location.lat();
        var lng = place.geometry.location.lng();

        formik.setFieldValue("address", place?.formatted_address);
        formik.setFieldValue("latitude", lat || "");
        formik.setFieldValue("longitude", lng || "");
      }
    }
  };
  const handleImageUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = event.target.files;
    const file = files?.length ? files[0] : null;

    try {
      if (!file) {
        formik.setFieldValue("profile_picture", "");
        setProfilePicture("");
        setImageId(null); // Reset if no file is selected
        return;
      }

      setIsLoading(true);
      const res = await UploadMedia(file);
      if (res?.status === 200) {
        setIsLoading(false);
        setImageId(res?.data[0]?.id); // Correctly set the image ID
        const imageUrl = res?.data[0]?.media_url;
        formik.setFieldValue("profile_picture", imageUrl); // Update Formik field
        setProfilePicture(imageUrl); // Set preview URL
        successToast("Image uploaded successfully.");
      } else {
        errorToast(res?.message); // Show error message
      }
    } catch (error) {
      console.error("Error uploading image:", error);
      setIsLoading(false);
      errorToast("Error uploading image. Please try again.");
      setImageId(null); // Reset ID in case of failure
    }
  };

  const fetchDataById = async (id: any) => {
    try {
      setIsLoading(true);
      const response = await fetchApi({ id: id }).unwrap();
      if (response.status === 200) {
        setByIdDetails(response?.data || []);
        setPhoneCode(response?.data?.dialCode || "");
        setImageId(response?.data?.profile_picture?.id);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (id) {
      fetchDataById(id);
    }
  }, [id]);

  const formik = useFormik({
    initialValues: {
      name: ByIdDetails?.full_name || "",
      email: ByIdDetails?.email || "",
      phone_no: ByIdDetails?.phone_no || "",
      profile_picture:
        ByIdDetails?.profile_picture?.media_url || profile_picture,
      dialCode: ByIdDetails?.country_code || dialCode,
      address: ByIdDetails?.address?.business_address || "",
      industry_type: ByIdDetails?.industry_type || "",
      city: ByIdDetails?.address?.city || "",
      pin_code: ByIdDetails?.address?.pin_code || "",
      // registrationNo: ByIdDetails?.registrationNo || "",
      businessName: ByIdDetails?.business_name || "",
    },
    validationSchema: Yup.object().shape({
      name: Yup.string().required("Name is required"),
      email: Yup.string()
        .required("Email is required")
        .matches(
          /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
          "Enter a valid email address"
        )
        .matches(
          /^[^\uD800-\uDBFF\uD800-\uDBFF]+$/, // Regex to disallow emojis
          "Emojis are not allowed in the email address"
        ),
      phone_no: Yup.string().required("Phone number is required"),
      address: Yup.string().required("Address is required"),
      businessName: Yup.string().required("Business Name is required"),
      pin_code: Yup.string().required("Pin code is required"),
      city: Yup.string().required("City is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      if (!formik.isValid) return;
      const body = {
        full_name: values.name || "",
        business_name: values.businessName || "",
        city: values.city || "",
        business_address: values.address || "",
        pin_code: values.pin_code || "",
        profile_picture: imageId || null,
        industry_type: values?.industry_type || "",
        phone_no: values?.phone_no || "",
      };

      if (id) {
        try {
          const response = await editUserByiD({ id, body }).unwrap();
          if (response?.status === 200) {
            setIsLoading(false);
            successToast(response?.message || "User updated successfully");
            navigate("/manage-users");
          }
        } catch (error: any) {
          errorToast(error?.data?.message);
        } finally {
          setSubmitting(false);
        }
      }
    },
  });
  const handleChangePhone = (phone: any, country: any) => {
    formik.setFieldValue("phone_no", phone?.replace(country?.dialCode, ""));
    setPhoneCode(
      country?.dialCode.includes("+")
        ? country?.dialCode
        : "+" + country?.dialCode
    );
  };

  useEffect(() => {
    if (ByIdDetails) {
      formik.setValues({
        name: ByIdDetails?.full_name || "",
        email: ByIdDetails?.email || "",
        phone_no: ByIdDetails?.phone_no || "",
        profile_picture: ByIdDetails?.profile_picture?.media_url || "",
        dialCode: ByIdDetails?.country_code || dialCode,
        // companyName: "",
        address: ByIdDetails?.address?.business_address || "",
        pin_code: ByIdDetails?.address?.pin_code || "",
        businessName: ByIdDetails?.business_name || "",
        city: ByIdDetails?.address?.city || "",
        industry_type: ByIdDetails?.industry_type || "",
      });
    }
  }, [ByIdDetails]);

  return (
    <div>
      <div className="main_loyout">
        <div className="dashboard">
          <h1 className="mn_hdng">{id ? "Edit Customer Profile" : null}</h1>
          <Loader isLoad={isLoading} />
          <Button
            className="btn btn_primary"
            onClick={() => {
              navigate("/manage-users");
            }}
          >
            {t.main.back}
          </Button>
        </div>
        <Card className="cards">
          <form onSubmit={formik.handleSubmit}>
            <CardContent sx={{ p: 0, pb: 0 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography className="custom_label">
                    {t.main.image} *
                  </Typography>
                  {formik.values.profile_picture ? (
                    <div className="upload_image_preview">
                      <CardMedia
                        component="img"
                        image={formik.values.profile_picture}
                        alt="photo"
                      />
                      <CancelIcon
                        onClick={(e) => {
                          e.preventDefault();
                          setProfilePicture("");
                          formik.setFieldValue("profile_picture", "");
                        }}
                      />
                    </div>
                  ) : (
                    <Box className="upload_image">
                      <label htmlFor="icon-button-file">
                        <Input
                          sx={{ display: "none" }}
                          id="icon-button-file"
                          type="file"
                          inputProps={{
                            accept: "image/png,image/jpeg",
                          }}
                          onChange={handleImageUpload}
                        />
                        <Button component="span" className="upload_image_btn">
                          <img
                            src="/static/images/user_placeholder.png"
                            alt=""
                          />
                          <CameraAltIcon />
                        </Button>
                      </label>
                    </Box>
                  )}
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Typography className="custom_label">
                    {t.main.fullName} *
                  </Typography>
                  <TextField
                    hiddenLabel
                    type={"text"}
                    name="name"
                    variant="outlined"
                    fullWidth
                    placeholder={t.main.fullName}
                    onBlur={formik.handleBlur}
                    value={formik.values.name}
                    className="text_field"
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    helperText={
                      formik.touched.name && formik.errors.name
                        ? formik.errors.name.toString()
                        : ""
                    }
                    error={formik.touched.name && Boolean(formik.errors.name)}
                  ></TextField>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Typography className="custom_label">
                    {t.main.email} *
                  </Typography>
                  <TextField
                    className="text_field"
                    hiddenLabel
                    type={"email"}
                    name="email"
                    variant="outlined"
                    fullWidth
                    placeholder={t.main.email}
                    value={formik.values.email}
                    disabled={true}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.email && formik.errors.email
                        ? formik.errors.email.toString()
                        : ""
                    }
                  ></TextField>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Typography className="custom_label">
                    {t.main.phoneNumber} *
                  </Typography>
                  <PhoneInput
                    value={dialCode + formik.values.phone_no}
                    country={"ae"}
                    placeholder="0 (000) 000-000"
                    enableSearch={true}
                    inputStyle={{ width: "100%" }}
                    onChange={(phone, country) =>
                      handleChangePhone(phone, country)
                    }
                    onBlur={formik.handleBlur}
                    disabled={true}
                  />
                  {formik.touched.phone_no && formik.errors.phone_no ? (
                    <h6 className="err_msg">
                      {formik.touched.phone_no &&
                        formik.errors.phone_no.toString()}
                    </h6>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <Typography className="custom_label">
                    {t.main.businessName} *
                  </Typography>
                  <TextField
                    className="text_field"
                    hiddenLabel
                    type={"test"}
                    name={t.main.businessName}
                    variant="outlined"
                    fullWidth
                    placeholder="Business Name"
                    value={formik.values.businessName}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    helperText={
                      formik.touched.businessName && formik.errors.businessName
                        ? formik.errors.businessName.toString()
                        : ""
                    }
                    error={
                      formik.touched.businessName &&
                      Boolean(formik.errors.businessName)
                    }
                  ></TextField>
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">
                      {t.main.industryType} *
                    </Typography>
                    <Select
                      labelId="category-label"
                      value={formik.values.industry_type || ""}
                      id="category-select"
                      name={t.main.industryType}
                      fullWidth
                      displayEmpty
                      onChange={(e) => {
                        // formik.setFieldValue("city", "");
                        // handleValueChange({ key: 'country', value: e.target.value });
                        formik.setFieldValue("industry_type", e.target.value);
                      }}
                      error={
                        formik.touched.industry_type &&
                        Boolean(formik.errors.industry_type)
                      }
                    >
                      <MenuItem value={""} disabled>
                        {t.main.selectIndustry}
                      </MenuItem>
                      {INDUSTRY_TYPE?.length
                        ? INDUSTRY_TYPE?.map(
                            (item: any, index: number) =>
                              item?.value && item?.label ? (
                                <MenuItem value={item.value} key={index}>
                                  {item.label}
                                </MenuItem>
                              ) : null // Skip items without value or label
                          )
                        : ""}
                    </Select>
                  </div>
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">
                      {t.main.address} *
                    </Typography>
                    <TextField
                      hiddenLabel
                      type="text"
                      className="text_field"
                      name="address"
                      variant="outlined"
                      fullWidth
                      placeholder={t.main.address}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.address}
                      helperText={
                        formik.touched.address &&
                        typeof formik.errors.address === "string"
                          ? formik.errors.address
                          : undefined
                      }
                      error={
                        formik.touched.address && Boolean(formik.errors.address)
                      }
                      // helperText={formik.touched.address && formik.errors.address}
                    />
                    {/* <Autocomplete
                    onLoad={onLoad}
                    onPlaceChanged={() => onPlaceChanged()}
                  >
                    <TextField
                      className="text_field"
                      hiddenLabel
                      name="address"
                      value={formik.values?.address}
                      placeholder="Enter Address"
                      fullWidth
                      helperText={
                        formik.touched.address &&
                        typeof formik.errors.address === "string"
                          ? formik.errors.address
                          : undefined
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.trim() === "" ||
                          e.target.value === "."
                        ) {
                          formik.setFieldValue("address", "");
                        } else {
                          formik.handleChange(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Autocomplete> */}
                  </div>
                </Grid>
                <Grid item lg={6} md={6} sm={6} xs={12}>
                  <div className="control_group w_50">
                    <Typography className="custom_label">
                      {t.main.pinCode} *
                    </Typography>
                    <TextField
                      hiddenLabel
                      type="text"
                      className="text_field"
                      name="pin_code"
                      variant="outlined"
                      fullWidth
                      placeholder={t.main.pinCode}
                      onChange={(val) => {
                        if (
                          val.target.value === " " ||
                          val.target.value === "."
                        ) {
                        } else {
                          formik.handleChange(val);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.pin_code}
                      error={
                        formik.touched.pin_code &&
                        Boolean(formik.errors.pin_code)
                      }
                      helperText={
                        formik.touched.pin_code &&
                        typeof formik.errors.pin_code === "string"
                          ? formik.errors.pin_code
                          : undefined
                      }
                    />
                    {/* <Autocomplete
                    onLoad={onLoad}
                    onPlaceChanged={() => onPlaceChanged()}
                  >
                    <TextField
                      className="text_field"
                      hiddenLabel
                      name="address"
                      value={formik.values?.address}
                      placeholder="Enter Address"
                      fullWidth
                      helperText={
                        formik.touched.address &&
                        typeof formik.errors.address === "string"
                          ? formik.errors.address
                          : undefined
                      }
                      onChange={(e) => {
                        if (
                          e.target.value.trim() === "" ||
                          e.target.value === "."
                        ) {
                          formik.setFieldValue("address", "");
                        } else {
                          formik.handleChange(e);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Autocomplete> */}
                  </div>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <Typography className="custom_label">
                    {t.main.city} *
                  </Typography>

                  <TextField
                    hiddenLabel
                    className="text_field"
                    type="text"
                    name="city"
                    variant="outlined"
                    fullWidth
                    placeholder={t.main.city}
                    onChange={(val) => {
                      if (
                        val.target.value === " " ||
                        val.target.value === "."
                      ) {
                      } else {
                        formik.handleChange(val);
                      }
                    }}
                    onBlur={formik.handleBlur}
                    value={formik.values.city}
                    error={formik.touched.city && Boolean(formik.errors.city)}
                    helperText={
                      formik.touched.city &&
                      typeof formik.errors.city === "string"
                        ? formik.errors.city
                        : undefined
                    }
                  />
                </Grid>
              </Grid>
              <div className="form_btn">
                <Button size="large" type="submit" className="btn btn_primary">
                  {t.main.update}
                </Button>
              </div>
            </CardContent>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default UsersForm;
